jQuery(function($){
    var slideAbout = $('.carousel-testimonies');
    if(slideAbout.length){
        slideAbout.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 4000,
            prevArrow: '<button type="button" class="slick-prev btn btn-link fs-3 p-1" aria-label="Previous"><img src="/assets/img/icone-prev.svg" alt="Anterior" width="35" height="35"></button>',
            nextArrow: '<button type="button" class="slick-next btn btn-link fs-3 p-1" aria-label="Next"><img src="/assets/img/icone-next.svg" alt="Próximo" width="35" height="35"></button>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1
                    }
                },{
                    breakpoint: 991,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                }
            ]
        });
    }
    var slideAbout = $('.carousel-testimonies-videos');
    if(slideAbout.length){
        slideAbout.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 4000,
            prevArrow: '<button type="button" class="slick-prev btn btn-link fs-3 p-1" aria-label="Previous"><img src="/assets/img/icone-prev.svg" alt="Anterior" width="35" height="35"></button>',
            nextArrow: '<button type="button" class="slick-next btn btn-link fs-3 p-1" aria-label="Next"><img src="/assets/img/icone-next.svg" alt="Próximo" width="35" height="35"></button>'
        });
    }
});